import { type FC, type ReactNode } from 'react';
import classnames from 'classnames';

import { ModalContainer } from 'dibs-elements/exports/ModalContainer.tsx';
import { Link } from 'dibs-elements/exports/Link.tsx';
import Close from 'dibs-icons/exports/Close.ts';

import styles from './MobileNotificationsModal.module.css';
import dibsCss from 'dibs-css';

const MobileNotificationsModal: FC<{ children: ReactNode; onClose: () => void }> = ({
    children,
    onClose,
}) => {
    return (
        <ModalContainer isOpen onClose={onClose} dataTn="notifications-modal-mobile">
            <div className={classnames(styles.closeButton, dibsCss.absolute, dibsCss.rightSmall)}>
                <Link onClick={onClose} dataTn="notifications-modal-mobile-close-button">
                    <Close variation="24" />
                </Link>
            </div>
            <div className={dibsCss.pbSmall}>{children}</div>
        </ModalContainer>
    );
};

export default MobileNotificationsModal;
